import { render, staticRenderFns } from "./LiveRoom.vue?vue&type=template&id=af3f7c5e&scoped=true"
import script from "./LiveRoom.vue?vue&type=script&lang=js"
export * from "./LiveRoom.vue?vue&type=script&lang=js"
import style0 from "./LiveRoom.vue?vue&type=style&index=0&id=af3f7c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3f7c5e",
  null
  
)

export default component.exports